<template>
  <div v-if="verified">
    <el-input v-model="input" v-debounce:300ms="requestBook" style="width: 240px" placeholder="Введите информацию" />
    <p></p>
    <h3>Поиск по книге:</h3>
    <DataTable :table-data="data" />
    <h3>Поиск по автору:</h3>
    <DataTable :table-data="author_data" />
  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash.debounce'
import DataTable from "@/components/DataTable";
export default {
  name: 'App',
  components: {DataTable},
  data() {
    return {
      input: '',
      data: [],
      author_data: [],
      verified:false,
    }
  },
  created() {
      axios.post(process.env.VUE_APP_URL+'/verify',{initData:window.Telegram.WebApp.initData}).then((response)=>{
        this.verified=response.data.verify;
      });
  },
  methods:{
    requestBook(e) {
      if (this.input.length>3)
      {



        axios.post(process.env.VUE_APP_URL+"/books",{query:this.input,initData:window.Telegram.WebApp.initData}).then( (response) => {

          this.data=response.data;
        })
            .catch(function (error) {
              console.log(error);
            });


/*        axios.post(process.env.VUE_APP_URL+"/books_author",{query:this.input,initData:window.Telegram.WebApp.initData}).then( (response) => {

          this.author_data=response.data;
        })
            .catch(function (error) {
              console.log(error);
            });*/


      }

    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
